<script>
export default {
  name: "MiniCardSpecialist",
  props: {

    specialist: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="miniCardSpecialist">
    <div class="minicardHead">
      <div class="logo">
        <img class="logoImage" :src="specialist.logo" alt="miniCardSpecialist" />
      </div>
      <div class="minicardHead__text">
        <div class="minicardHead__title">
          {{ specialist.name }}
          <span v-if="specialist.verified" class="minicardHead__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path opacity="0.34" d="M6.9834 9.99909L8.99173 12.0158L13.0167 7.98242" stroke="#1A1A1A"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.9584 2.04258C9.5334 1.55091 10.4751 1.55091 11.0584 2.04258L12.3751 3.17591C12.6251 3.39258 13.0917 3.56758 13.4251 3.56758H14.8417C15.7251 3.56758 16.4501 4.29258 16.4501 5.17591V6.59258C16.4501 6.91758 16.6251 7.39258 16.8417 7.64258L17.9751 8.95925C18.4667 9.53425 18.4667 10.4759 17.9751 11.0592L16.8417 12.3759C16.6251 12.6259 16.4501 13.0926 16.4501 13.4259V14.8426C16.4501 15.7259 15.7251 16.4509 14.8417 16.4509H13.4251C13.1001 16.4509 12.6251 16.6259 12.3751 16.8426L11.0584 17.9759C10.4834 18.4676 9.54173 18.4676 8.9584 17.9759L7.64173 16.8426C7.39173 16.6259 6.92506 16.4509 6.59173 16.4509H5.15006C4.26673 16.4509 3.54173 15.7259 3.54173 14.8426V13.4176C3.54173 13.0926 3.36673 12.6259 3.1584 12.3759L2.0334 11.0509C1.55007 10.4759 1.55007 9.54258 2.0334 8.96758L3.1584 7.64258C3.36673 7.39258 3.54173 6.92591 3.54173 6.60091V5.16758C3.54173 4.28424 4.26673 3.55924 5.15006 3.55924H6.59173C6.91673 3.55924 7.39173 3.38424 7.64173 3.16758L8.9584 2.04258Z"
                stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>
        <div class="minicardHead__vacansies">
          {{ specialist.resume.infoVakanci.name }}
        </div>
      </div>
      <div class="links_specialist">
        <a  class="link wishlist">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M10.5166 17.3417C10.2333 17.4417 9.76663 17.4417 9.48329 17.3417C7.06663 16.5167 1.66663 13.075 1.66663 7.24171C1.66663 4.66671 3.74163 2.58337 6.29996 2.58337C7.81663 2.58337 9.15829 3.31671 9.99996 4.45004C10.8416 3.31671 12.1916 2.58337 13.7 2.58337C16.2583 2.58337 18.3333 4.66671 18.3333 7.24171C18.3333 13.075 12.9333 16.5167 10.5166 17.3417Z"
              stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </a>
        <a class="link rating">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M11.4417 2.92495L12.9084 5.85828C13.1084 6.26662 13.6417 6.65828 14.0917 6.73328L16.75 7.17495C18.45 7.45828 18.85 8.69162 17.625 9.90828L15.5584 11.975C15.2084 12.325 15.0167 13 15.125 13.4833L15.7167 16.0416C16.1834 18.0666 15.1084 18.85 13.3167 17.7916L10.825 16.3166C10.375 16.05 9.63338 16.05 9.17505 16.3166L6.68338 17.7916C4.90005 18.85 3.81671 18.0583 4.28338 16.0416L4.87505 13.4833C4.98338 13 4.79171 12.325 4.44171 11.975L2.37505 9.90828C1.15838 8.69162 1.55005 7.45828 3.25005 7.17495L5.90838 6.73328C6.35005 6.65828 6.88338 6.26662 7.08338 5.85828L8.55005 2.92495C9.35005 1.33328 10.65 1.33328 11.4417 2.92495Z"
              fill="#1A1A1A" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ specialist.rating }}
        </a>
      </div>
    </div>
    <div class="minicardBody">
      <div class="ratingSpecialist">
        <div class="ratingSpanWrp"><span class="ratingSpan">{{ specialist.transferRating }}</span></div>
      </div>
      <div class="minicard_item">
        <div class="value">{{ specialist.resume.infoVakanci.experience }}</div>
        <span class="label">лет опыта</span>
      </div>
      <div class="minicard_item">
        <div class="value">{{ specialist.resume.infoVakanci.ransom }}</div>
        <span class="label">стоимость</span>
      </div>
      <div class="minicard_item">
        <div class="value">{{ specialist.resume.infoVakanci.solary }}</div>
        <span class="label">зарплата</span>
      </div>
    </div>
    <div class="minicardFooter">
      <div class="subscriptions">
        {{ specialist.subscriptions }} Подписок
      </div>
      <div class="minicards__links">
        <a class="btn-opacity">Подписаться</a>
        <a class="btn-opacity">Подробнее</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.miniCardSpecialist {
  border-radius: 20px;
  background: #fff;
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.minicardHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.logo {
  border-radius: 15px;
  background: #f4f8fb;
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logoImage {
  width: 100%;
}

.minicardHead__text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-right: auto;
}

.minicardHead__title {
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 5px;
}

.minicardHead__icon {
  display: flex;
}

.minicardHead__vacansies {
  color: #80879c;
  font-family: Aeroport;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.links_specialist {
  display: flex;
  gap: 10px;
}

.rating {
  color: #1a1a1a;
  text-align: center;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  gap: 5px;
}

.minicardBody {
  display: flex;
  align-items: center;
  gap: 10px;
}

.minicard_item {
  border-radius: 10px;
  background: #f4f8fb;
  width: 110px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  text-align: center;
}

.value {
  color: #1a1a1a;
  text-align: center;
  font-family: Aeroport;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.label {
  color: #80879c;
  text-align: center;
  font-family: Aeroport;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.minicardFooter {
  margin-top: 13.5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.subscriptions {
  color: #1a1a1a;
  font-family: Aeroport;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 5px;
}

.minicards__links {
  display: flex;
  align-items: center;
  gap: 15px;
}

.ratingSpecialist {
  width: 77px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
  padding-bottom: 6px;
}

.ratingSpan {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #70f;
  color: #fff;
  text-align: center;
  font-family: Aeroport;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: relative;
  z-index: 2;
  padding: 6px;
}

.ratingSpanWrp {
  position: relative;
  width: max-content;
  height: max-content;
}

.ratingSpanWrp::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1px;
  height: 97px;
  border-radius: 50%;
  background: #E9F0F8;
  z-index: 1;
  transform: translate(0, -50%);
}
.wishlist{
  display: flex;
  align-items: center;
}
@media (max-width: 650px) {
  .miniCardSpecialist {
    width: 100%;
    padding: 15px;
  }
  .ratingSpecialist {
    display: none;  
  }
  .minicardBody {
    gap: 5px;
  }
  .minicard_item {
    padding: 11px;
    gap: 1px;
  }
  .logo {
    width: 65px;
    height: 65px;
    border-radius: 15px;
  }
  .minicardHead__title {
    font-size: 16px;
  }
  .minicardHead__vacansies {
    font-size: 14px;
  }
  .links_specialist {
    gap: 6px;
  }
  .wishlist svg {
    width: 18px;
    height: 18px;
  }
  .btn-opacity {
    font-size: 14px;
    padding: 12px;
    min-width: 102px;
  }
}
</style>